
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("UsuarioZE");
const crud = rpcCrudService<models.UsuarioZE, models.UsuarioZEDto>(controller);

export interface DatosRepetidoUsuarioZE {
    idUsuarioZE: number | null;
}

export const UsuarioZE = cacheResource({
    ...crud,

    //QueryByUsuario

    QueryByUserRol: async (): Promise<models.UsuarioZEDto[]> => await controller('QueryByUserRol', {}),

    Query: async (filtro: models.FiltroUsuarioZE): Promise<models.UsuarioZEDto[]> => await controller('Query', {}, filtro),

    RepetidoIdentificacion: async (valor: string, campo: CampoRepetidoIdentificacion, datos: DatosRepetidoUsuarioZE): Promise<boolean> => await controller("Repetido" + campo, { ...datos, valor }),

    GuardarVehiculoZE:async (vehiculo: models.VehiculoZE): Promise<models.VehiculoZE> => await controller('GuardarVehiculoZE', {}, vehiculo),

    BorrarVehiculoZE:async( vehiculo: models.VehiculoZE ):Promise<models.RespuestaBorrado> => await controller("BorrarVehiculoZE",{},vehiculo),

    GuardarChoferZE:async (chofer: models.ChoferZE): Promise<models.ChoferZE> => await controller('GuardarChoferZE', {}, chofer),

    BorrarChoferZE:async( chofer: models.ChoferZE ):Promise<models.RespuestaBorrado> => await controller("BorrarChoferZE",{},chofer),

    GetClabe:async (id: number): Promise<string> => await controller('GetClabe', { id }),

    GetFormaPago:async (id: number): Promise<number> => await controller('GetFormaPago', { id }),

    GetGuiasEnVehiculo: async (idUsuarioZE:number): Promise<models.GuiaDTO[]> => await controller("GetGuiasEnVehiculo",{ idUsuarioZE }),
}, {
        Query: true,
        getMemo: true,
        GetClabe:true,
        GetFormaPago: true
    }, {
        add: true,
        delete: true,
        update: true
    });
const test: ResourceIdentificacionRepetido<DatosRepetidoUsuarioZE> = UsuarioZE;


// WEBPACK FOOTER //
// ./app/resources/items/usuarioze.ts